// extracted by mini-css-extract-plugin
export default {"inputsWrapper":"BaseForm_inputsWrapper__692OG"};